import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {filter} from "rxjs";
import {NavigationEnd, Router} from "@angular/router";
import {IonicModule} from "@ionic/angular";
import {NavigationService} from "../../services/navigations/navigation.service";

@Component({
  selector: 'app-panel-header',
  templateUrl: './panel-header.component.html',
  styleUrls: ['./panel-header.component.scss'],
  imports: [
    TranslatePipe,
    IonicModule
  ],
  standalone: true
})
export class PanelHeaderComponent implements OnInit {
  @Output('backDetect') backDetect: EventEmitter<any> = new EventEmitter<any>();
  @Input('showBack') showBack: boolean = true;

  public panelHeaderLabel: string = 'lbl_home'

  private router: Router = inject(Router)
  private navigationService: NavigationService = inject(NavigationService)

  public ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setPanelHeaderLabel();
      });
  }

  private setPanelHeaderLabel() {
    const segments = this.router.url.split('?')[0].split('/');
    const labelMap: Record<string, string> = {
      'other-profile': 'lbl_other_profile',
      'action-point': 'lbl_action_point',
      'personal-data': 'hdl_profile',
      'app-settings': 'lbl_app_settings',
      'edit-company': 'lbl_edit_company',
      'edit-team': 'lbl_edit',
      'change-password': 'lbl_change_password',
      'my-invitations': 'lbl_invites',
      'edit-profile': 'lbl_edit_profile',
      'notifications': 'lbl_notifications',
      'profile': 'lbl_profile',
      'my-company': 'lbl_my_companies',
      'company': 'lbl_company',
      'other-team': 'lbl_space',
      'view-team': 'lbl_space',
      'create-team': 'lbl_create_space',
      'team': 'lbl_teams',
      'moment': 'lbl_moment',
      'action_point': 'lbl_action_point',
      'view-post': 'lbl_view_post',
      'edit-action-point': 'lbl_edit_action_point',
      'edit-post': 'lbl_edit_post',
      'forgot-password': 'lbl_forgot_password',
      'interaction': 'lbl_interaction',
      'leaf': 'lbl_impact',
      'login': 'lbl_login',
      'register': 'lbl_register',
      'user-profile': 'lbl_other_profile',
      'welcome': 'lbl_welcome',
      'intro': 'lbl_intro',
      'map-moment': 'lbl_moment',
      'point-of-action-details': 'lbl_poa',
      'search': 'lbl_search',
      'create-moments': 'lbl_create_moments',
      'post-modal': 'hdl_create_post',
      'create-post': 'lbl_create_post',
    };


    const foundKey = Object.keys(labelMap).find(key => segments.includes(key));
    this.panelHeaderLabel = foundKey ? labelMap[foundKey] : 'lbl_home';
  }

  back(): void {
    this.backDetect.emit(true);
    this.navigationService.triggerResetMarker();
    this.navigationService.back(this.router.url);
  }
}
